import { ModelSagresDatatable } from "@/types/model-sagres-datatable";

type VencedorItemModalApi = {
  IdParticipanteLicitacao?: number;
  QtLicitada?: number;
  VlUnitarioLicitado?: number;
  NmMarcaItemMatServ?: string;
};

type ItemModalVencedorApi = {
  IdItemLicitacao?: number;
  NuSequencialItem?: number;
  DeItemMatServ?: string;
  QtItemMatServ?: number;
  DeUnidadeMedida?: string;
  VlUnitarioEstimado?: number;
  Vencedores?: VencedorItemModalApi[];
};

/**
 * Armazena apenas os dados necessários para informar que um item foi vencido por um determinado participante.
 * O participante e o id da licitação, inicialmente, não ficarão nesta entidade.
 *
 * @since 20240315
 */
export class ItemModalVencedorLicitacao extends ModelSagresDatatable {
  IdItemLicitacao: number;

  //o que aparece na tabela, em ordem
  selecionado: boolean; //esse aqui é transient, se muitas telas usarem a gente joga no ModelDatatable
  NuSequencialItem: number;
  DeItemMatServ: string;
  QtItemMatServ: number;
  /** Quantidade disponível para este participante: total menos o que outros vencedores já têm. */
  QtDisponivelParaLicitar: number;
  DeUnidadeMedida: string;
  QtLicitada?: number; //últimos 3 da tabela são user input
  VlUnitarioLicitado?: number;
  NmMarcaItemMatServ?: string;

  //auxiliares para preencher os inputs com sugestões
  VlUnitarioEstimado?: number;

  /**
   * Usar o parâmetro opcional para receber um objeto da API
   * @param obj
   */
  constructor(
    obj?: ItemModalVencedorApi,
    idParticipante?: number
  ) {
    super();
    this.selecionado = false;
    if (obj) {
      if (obj.IdItemLicitacao === undefined || obj.IdItemLicitacao === null) {
        console.warn("[LDI] Item sem IdItemLicitacao recebido da API, ignorado:", obj);
        return;
      }
      this.IdItemLicitacao = obj.IdItemLicitacao;
      this.NuSequencialItem = obj.NuSequencialItem ?? 0;
      this.DeItemMatServ = obj.DeItemMatServ ?? "";
      this.QtItemMatServ = obj.QtItemMatServ ?? 0;
      this.DeUnidadeMedida = obj.DeUnidadeMedida ?? "";
      this.VlUnitarioEstimado = obj.VlUnitarioEstimado;

      const qtOutros = idParticipante !== undefined
        ? (obj.Vencedores ?? [])
            .filter((v) => v.IdParticipanteLicitacao !== idParticipante)
            .reduce((acc, v) => acc + (v.QtLicitada ?? 0), 0)
        : 0;
      this.QtDisponivelParaLicitar = Math.max(0, this.QtItemMatServ - qtOutros);

      this.QtLicitada = this.QtDisponivelParaLicitar;
      this.VlUnitarioLicitado = obj.VlUnitarioEstimado;
      if (obj.Vencedores && obj.Vencedores.length > 0) {
        const vencedor = obj.Vencedores.find(
          (v) => v.IdParticipanteLicitacao === idParticipante
        );
        if (vencedor) {
          this.selecionado = true;
          this.QtLicitada = vencedor.QtLicitada;
          this.VlUnitarioLicitado = vencedor.VlUnitarioLicitado;
          this.NmMarcaItemMatServ = vencedor.NmMarcaItemMatServ;
        }
      }
    }
  }
}
